import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ButtonComponent implements OnInit {
  //Text : button naming.
  @Input() public text: string = 'Action';

  //Type : button styling : primary / outlined / lite / text.
  @Input() public btnType: string = 'primary';

  //Color : button color : primary / danger.
  @Input() public color: string = 'primary';

  //Icon : button icon : svg / mat-icon.
  @Input() public icon: string = '';

  //iconPosition : center / left-icon / right-icon.
  @Input() public iconPosition: string = 'center';

  //iconType : 'image' / 'mat-icon'.
  @Input() public iconType: string = 'mat-icon';

  @Input() public svgIcon?: string;

  @Input() public fxLayoutAlignParam: string = 'center center';

  @Input() public isSpinner: boolean = false;

  @Input() public isSpinning: boolean = false;

  @Input() public iconOnly: boolean = false;

  @Input() public disabled: boolean = false;

  @Input() public badge: number = 0;

  @Input() public NotAllowedCursor: boolean = false;

  @Input() public hoverBackground: boolean = true;

  @Input() public isSmall: boolean = false;

  @Input() public isPillDesign: boolean = false;

  @Input() public multilineText: boolean = true;

  @Output() public isLoaded = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {
    this.isLoaded.emit(true);
  }

  stopPropagation(event: any) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
}
